import { z } from 'zod';

export const bankDetailsFormSchema = z.object({
  id: z.string(),
  bankName: z.string().min(3),
  bankAddress: z.string().min(3),
  currentAccount: z.string().min(3),
  correspondentAccount: z.string().min(3),
  currency: z.string().min(1),
  bik: z.string().min(3).max(11),
  swift: z.string(),
  defaultDetails: z.boolean(),
});
